import React from "react";
import { observer } from "mobx-react";
import { observable } from "mobx";
import { Grid } from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";
import Typography from "@material-ui/core/Typography";
import { Values } from "Tools/Values";
import TransferWithinAStation from "@material-ui/icons/TransferWithinAStation";
import HandoverForm from "./HandoverForm";
import SimpleModal from "@src/Components/Common/SimpleModal/SimpleModal";
import { STModalWrapper } from "./styles";
import { MenuIcon } from "../AccountMenu/styles";

interface IProps {}

@observer
export default class HandoverMenuItem extends React.Component<IProps> {
  @observable opened: boolean = false;

  handleOpen = () => {
    this.opened = true;
  };

  handleClose = () => {
    this.opened = false;
  };

  render() {
    return (
      <React.Fragment>
        <MenuItem onClick={this.handleOpen}>
          <MenuIcon>
            <TransferWithinAStation fontSize="small"/>
          </MenuIcon>
          <Typography variant="inherit">{Values.getLocalizationValue("handover")}</Typography>
        </MenuItem>
        <SimpleModal width={650} isOpened={this.opened} onClose={this.handleClose}>
          <STModalWrapper container>
            <Grid container justify="center">
              <HandoverForm onClose={this.handleClose} />
            </Grid>
          </STModalWrapper>
        </SimpleModal>
      </React.Fragment>
    );
  }
}
